import { Pipe, PipeTransform } from '@angular/core';

export const userAvatarFn = (value: { firstName: string; lastName: string }): string => {
  const firstLetterStr1 = value.firstName.charAt(0);
  const firstLetterStr2 = value.lastName.charAt(0);
  const capitalizedFirstLetterStr1 = firstLetterStr1.toUpperCase();
  const capitalizedFirstLetterStr2 = firstLetterStr2.toUpperCase();

  return capitalizedFirstLetterStr1 + capitalizedFirstLetterStr2;
};

@Pipe({
  name: 'userAvatar',
  standalone: true,
})
export class UserAvatarPipe implements PipeTransform {
  transform(value: { firstName: string; lastName: string }): string {
    this;
    return userAvatarFn(value);
  }
}
